import React from 'react';
import Table from '../common/Table';
import tableConfig, { data } from './config';

const NewsLetter = (props) => {
  const classes = props.classes;

  const onRepeat = () => { console.log("onRepeat") }
  
  let config = tableConfig(props, onRepeat);

  return (<Table 
    tableConfig={config} 
    data={data}
  />)
};

export default NewsLetter;
